import { render, staticRenderFns } from "./Jobduty.vue?vue&type=template&id=7c153fc5&scoped=true&"
import script from "./Jobduty.vue?vue&type=script&lang=ts&"
export * from "./Jobduty.vue?vue&type=script&lang=ts&"
import style0 from "./Jobduty.vue?vue&type=style&index=0&id=7c153fc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c153fc5",
  null
  
)

export default component.exports